import { Box, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import Slider from "dependencies/carousel"

const Faq = styled(Box).attrs({
  px: 5,
  textAlign: "center",
})``

const SliderWrapper = styled(Slider)`
  button[aria-label="next"],
  button[aria-label="previous"] {
    top: 70px;
  }
`

const ArrowImg = styled.img`
  margin: 0 auto;
  position: relative;
`

const Arrow = ({ next }) => {
  return (
    <ArrowImg
      alt={`Go to ${next ? "next" : "previous"} question`}
      className="lazyload"
      data-src={require("images/icons/arrow_left_dark.svg")}
      src={require("images/icons/jewlr.gif")}
      width="15"
    />
  )
}

Arrow.propTypes = {
  next: PropTypes.bool,
}

const FAQCarousel = ({ questions }) => {
  const sliderSettings = {
    defaultControlsConfig: {
      nextButtonText: <Arrow next />,
      prevButtonText: <Arrow />,
    },
    dots: false,
    frameAriaLabel: "Klarna FAQ",
    speed: 200,
  }

  return (
    <MediaBox lessThan="tablet" mb={6} mx={2}>
      <SliderWrapper {...sliderSettings}>
        {questions.map((q, i) => (
          <Faq key={i}>{q}</Faq>
        ))}
      </SliderWrapper>
    </MediaBox>
  )
}
FAQCarousel.propTypes = {
  questions: PropTypes.array,
}
export default FAQCarousel
